import * as React from "react";

export const Medicine = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 10.1429V8.85714H15V12.7143C15 13.4107 14.3711 14 13.6875 14H2.3125C1.60156 14 1 13.4107 1 12.7143V8.85714H6.25V10.1429C6.25 10.3839 6.44141 10.5714 6.6875 10.5714H9.3125C9.53125 10.5714 9.75 10.3839 9.75 10.1429ZM13.6875 4.57143C14.3711 4.57143 15 5.1875 15 5.85714V8H1V5.85714C1 5.1875 1.60156 4.57143 2.3125 4.57143H4.5V3.28571C4.5 2.61607 5.10156 2 5.8125 2H10.1875C10.8711 2 11.5 2.61607 11.5 3.28571V4.57143H13.6875ZM9.75 4.57143V3.71429H6.25V4.57143H9.75Z"
    />
);
